// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2qRMq","questions":"styles_questions__eqbJp","footer":"styles_footer__1HhoY"};